export default "__VITE_ASSET__B2VTqLl9__"